import React from "react";
import { H2 } from "theme/components/atoms/Typography/Heading";
import { FormattedMessage } from "react-intl";

const Details = (props) => (
  <div className="product-details">
    <H2>
      <FormattedMessage
        id="modules.ProductView.Details.additionalInformation"
        defaultMessage="Additional information"
      />
    </H2>
    <dl className="product-details__list">
      {props.additionalInformation &&
        props.additionalInformation.map(({ attribute, values }, index) => (
          <div key={index} className="product-details__list__item">
            <dt className="product-details__list__item__label">
              {attribute.label}
            </dt>
            <dd className="product-details__list__item__content">
              {values &&
                values.map((value, index) => (
                  <span key={index}>{value.label}</span>
                ))}
            </dd>
          </div>
        ))}
    </dl>
  </div>
);

export default Details;
